import React from 'react';
import * as THREE from 'three';
import { useLocation } from 'react-router-dom';


import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass';

import {RenderPass} from 'three/examples/jsm/postprocessing/RenderPass';
import {EffectComposer} from 'three/examples/jsm/postprocessing/EffectComposer';
import {UnrealBloomPass} from 'three/examples/jsm/postprocessing/UnrealBloomPass';

import fresnelMatcap from '../img/fresnel_matcap.png';

import  heart_vessels from '../3D/heart_vessels.glb';
// import particleTexture from '../img/particle_alpha.png';
import background from '../img/glowBackground.png';


// import fresnel_vertex from '../shaders/fresnel_vertex.glsl';
// import fresnel_fragment from '../shaders/fresnel_fragment.glsl';
let flowMaterial;
let heartObj;

const HeartScene = () => {
  const { useRef, useEffect, useState } = React
  const location = useLocation();
const previousLocation = useRef();

  const mount = useRef(null)
  const [isAnimating, setAnimating] = useState(true)

  // const [isMobile, setIsMobile] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const controls = useRef(null)



  let gu = {
    time: {value: 0}
  }


  useEffect(() => {
    let width = mount.current.clientWidth
    let height = mount.current.clientHeight
    let frameId;
    let group = new THREE.Group();
    let group2 = new THREE.Group();
    let dashedMaterial;


    
    const targetRotation = new THREE.Quaternion();
let cameraScale;
let pointsMatSize;

    let initRotation;

    // var texturePass = new THREE.TexturePass();
    var textureLoader = new THREE.TextureLoader();
    var backTexture = textureLoader.load( background, function (  ) 
    {
      //texturePass.map = map;
    });

    function isMobile() {
      const userAgent = window.navigator.userAgent;
      return /Mobile/.test(userAgent);
    }

    
    THREE.Cache.enabled = true;

    const scene = new THREE.Scene()

scene.background=backTexture;

// scene.background = new THREE.Color( 0x22232E );
    // const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
        const camera = new THREE.PerspectiveCamera(65, width / height, 0.1, 1000)
        camera.position.x = -0.15;
        camera.position.y = 0.65;

        //ternary operator
        cameraScale = isMobile() ? 200 : 100;


        camera.position.z = 4*(window.innerWidth+cameraScale)/window.innerWidth;
;
    const renderer = new THREE.WebGLRenderer({ alpha: true })


    
// const controls = new OrbitControls(camera, renderer.domElement);

//     controls.screenSpacePanning = false;

var parameters = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBAFormat, stencilBuffer: false };

let renderTarget = new THREE.WebGLRenderTarget( width, height, parameters );

    renderer.setSize(width, height)
    renderer.setPixelRatio(window.devicePixelRatio);
   
    let composer = new EffectComposer(renderer, renderTarget);

    const renderPass = new RenderPass(scene, camera);

    renderPass.clearColor = new THREE.Color(1, 1, 1);

    renderPass.clearAlpha = 0;
    composer.addPass(renderPass);

renderer.clearColor = new THREE.Color(1, 1, 0);

const bloomPass = new UnrealBloomPass(new THREE.Vector2(width, height));
bloomPass.exposure=1.05;
bloomPass.threshold = 0.55;
bloomPass.strength = 1.15;
bloomPass.radius = .525;
composer.addPass(bloomPass);


const pass = new SMAAPass( window.innerWidth * renderer.getPixelRatio(), window.innerHeight * renderer.getPixelRatio() );
composer.addPass( pass );




    const geometry = new THREE.BoxGeometry(1, 1, 1)
    const material = new THREE.MeshBasicMaterial({ color: 0x77CDE7 })
    const cube = new THREE.Mesh(geometry, material)
    const planeGeo = new THREE.PlaneGeometry( 1, 1, 1, 1 );
let myocardialBand;
    let heartLoaded = false;
    const vertexParticles_vertex = `
    uniform float time;
    varying vec2 vUv;
    varying vec3 vPosition;
    uniform sampler2D texture1;
    float PI = 3.1415926535897932384626433832795;
    void main() {
      vUv = uv;
      vec4 modelViewPosition = modelViewMatrix * vec4(position, 1.0);
      gl_PointSize=1000.*(1./-modelViewPosition.z);
      gl_Position = projectionMatrix * modelViewPosition;)`

    const vertexParticles_fragment = `
    uniform float time;
    uniform float progress;
    uniform sampler2D texture1;
    uniform vec4 resolution;
    varying vec2 vUv;
    varying vec3 vPosition;
    varying float vColorRandom;
    `

    // var matLoader = new THREE.TextureLoader();

    // var glowMatcap = matLoader.load('./img/brainMatcap.png', function () {
    
    //   glowMatcap.encoding = THREE.LinearEncoding;
    //   // brainMatcap.encoding = THREE.sRGBEncoding;
    //   glowMatcap.toneMapped = true
    
    // });


      // let pointMaterial = new THREE.ShaderMaterial({

      //   extensions:{
      //     derivatives: '#extension GL_OES_standard_derivatives : enable',
      //   },
      //   side : THREE.DoubleSide,
      //   uniforms: {
      //     time: { value: 0 },
      //     resolution: { value: new THREE.Vector4() },
      // },
      // vertexShader: vertexParticles_vertex}
      
      // );

    // const pointPlane = new THREE.Mesh( planeGeo, pointMaterial );

const fresnel_fragment= `uniform vec3 glowColor;
varying float intensity;
void main()
{
    vec3 glow = glowColor * intensity;
    gl_FragColor = vec4( glow, 1.0 );
}`

const fresnel_vertex= `uniform float p;
varying float intensity;
void main()
{
  vec3 vNormal = normalize( normalMatrix * normal );
  intensity = pow(1.1 - abs(dot(vNormal, vec3(0,0, 1.1))), p);
  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`

let matLoader = new THREE.TextureLoader();
let matcapTexture = matLoader.load(fresnelMatcap);

    const glowMaterial = new THREE.ShaderMaterial({
      vertexShader: fresnel_vertex,
      fragmentShader: fresnel_fragment,
      uniforms: {
       
        p: { type: "f", value: 7 },
        glowColor: { type: "c", value: new THREE.Color(0x1671A5) },
      },
      
      side: THREE.DoubleSide,
      blending: THREE.AdditiveBlending,
      transparent: false,
      depthWrite: true,
      depthTest: false

    });


        let dashUniforms = {
          time: {value: 0},
        }

    let uniforms = {
      mouse: {
        value: new THREE.Vector3()
      },
      radius: {
        value: 1
      },
      time: {value: 0},
      cameraPosition: {value: new THREE.Vector3()}
    };


    // let glowMaterial = new THREE.MeshMatcapMaterial({
    //   matcap: matcapTexture,
    //   transparent: true,
    //   opacity: 0.7,
    //   side: THREE.FrontSide,
    //   depthWrite: false,
    //   depthTest: false,
    //   blending: THREE.AdditiveBlending,
    //   // wireframe: true,
    // });


    let pointMat = new THREE.PointsMaterial({
      // alphaMap:particleTexture,
      size:     isMobile()? 0.015:0.02      ,
      
      color: 0xE77168,
      // transparent: true,
      // alphaMap: particleTexture,
    });
    pointMat.onBeforeCompile = shader => {
      shader.uniforms.mouse = uniforms.mouse;
      shader.uniforms.radius = uniforms.radius;
      //console.log(shader.vertexShader);
      shader.vertexShader = `
        uniform vec3 mouse;
        uniform float radius;
      ` + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace(
        `#include <begin_vertex>`,
        `#include <begin_vertex>
          
          vec3 dir = transformed - mouse;
          
          float dist = length(dir);
          
          if (dist < radius){
            float ratio = 1. - dist / radius;
    
            vec3 shift = dir * 2. * (ratio * ratio);
    
            transformed += shift;
          }
        
        `
      );
    }
    glowMaterial.onBeforeCompile = shader => {
      shader.uniforms.mouse = uniforms.mouse;
      shader.uniforms.radius = uniforms.radius;
      shader.vertexShader = `
        uniform vec3 mouse;
        uniform float radius;
      ` + shader.vertexShader;
      shader.vertexShader = shader.vertexShader.replace(
        `#include <begin_vertex>`,
        `#include <begin_vertex>
          
          vec3 dir = transformed - mouse;
          
          float dist = length(dir);
          
          if (dist < radius){
            float ratio = 1. - dist / radius;
    
            vec3 shift = dir * 2. * (ratio * ratio);
    
            transformed += shift;
          }
        
        `
      );
    }

    let clock = new THREE.Clock();
    let loadingManager = new THREE.LoadingManager();
    const loadingScreenTop = document.querySelector('#section-top');
    const loadingScreenBottom = document.querySelector('#section-bottom');
    const loaderWrapper = document.querySelector('#loader-wrapper');
    let progessBar = document.querySelector('.progress-bar');
    let progessBarFill = document.querySelector('.progress-bar__fill');
    let progressText = document.querySelector('.progress-text p');


    if (!heartLoaded)
  {  loadingManager.onStart = function (url, itemsLoaded, itemsTotal) {



    }
    
    loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {

//progressBar

      progessBarFill.style.width = itemsLoaded / itemsTotal * 100 + '%';
    
    }
    
    loadingManager.onLoad = function () {
      progressText.classList.remove('flashing-animation');
      progessBarFill.style.background = '#39B3D6';
    
      
      progressText.innerHTML = 'Loaded';
      progressText.style.fontWeight = 'bold';
    
      function openScreen() {
    
        progressText.classList.add('loaded');
    
        loadingScreenTop.classList.add('loaded');
        loadingScreenBottom.classList.add('loaded');
        progessBar.classList.add('progress-loaded');
        progessBar.classList.add('hide-loadbar');
    
    
    
    
    
    
        loadingScreenTop.classList.add('fade-up');
        loadingScreenBottom.classList.add('fade-down');
    
        loadingScreenTop.addEventListener('transitionend', onTransitionEnd);
      }
    
      setTimeout(openScreen, 500);    
    
    }
    
    function onTransitionEnd() {
      console.log('transition ended');
      if (loaderWrapper != null) {
        loaderWrapper.remove();
      }
      // const element = event.target;
      // element.remove();
    
    }}
    
    const dracoLoader = new DRACOLoader()
    // dracoLoader.setDecoderPath( '../node_modules/three/examples/js/libs/draco/' )
    dracoLoader.setDecoderPath( 'https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/jsm/libs/draco/' )

    // dracoLoader.setDecoderPath( 'https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/' )
    // dracoLoader.setDecoderConfig({ type: 'js' });


    let loader = new GLTFLoader(loadingManager);
    loader.setDRACOLoader( dracoLoader );
    loader.crossOrigin = true;
    loader.load(heart_vessels, function (heart) {
      // loader.load('molecule.glb', function (heroModel) {
    
    
        heartObj = heart.scene;
        heartObj.children[1].position.set(0, 0, 0);
        heartObj.children[0].position.set(0, 0, 0);
        heartObj.children[1].material = glowMaterial;
        myocardialBand=heartObj.children[0].mesh;
        heartObj.children[0].layers.set(5);
        // heartObj.children[0].material =pointMaterial;
        // console.log(heartObj.children[1]);
    scene.add(heartObj);
    setIsLoaded(true);
    heartLoaded = true;


    if (   heartLoaded  ) {
        var cyl = new THREE.Points(heartObj.children[0].geometry, pointMat);
        uniforms.mouse.value= new THREE.Vector3(0,100,0);
        cyl.position.set(heartObj.children[0].position.x,heartObj.children[0].position.y,heartObj.children[0].position.z);
        scene.add(cyl);
      

      }





      let points1 = [
        [0.5735983848571777, -0.56218421459198, 0.2018490582704544] ,
        [0.11713248491287231, -0.5955781936645508, 0.31991705298423767] ,
        [-0.8498016595840454, -0.35751914978027344, 0.18928976356983185] ,
        [-0.29188138246536255, 0.5577372312545776, -0.3036893606185913] ,
        [0.4414353370666504, 0.6999308466911316, 0.4195792078971863] ,
        [0.34286653995513916, 0.49818167090415955, 0.6637205481529236] ,
        [0.13333307206630707, 0.3115525245666504, 0.7673192024230957] ,
        [-0.14512941241264343, -0.06768141686916351, 0.44555023312568665] ,
        [0.6445708274841309, 0.3038998544216156, -0.4589974582195282] ,
        [0.9183262586593628, 0.217930406332016, 0.2070198357105255] ,
        [0.09936921298503876, 0.22665473818778992, 0.8268649578094482] ,
        ];
        let points2 = [
          [0.5629226565361023, -0.61661297082901, 0.08911880850791931] ,
          [0.03285893797874451, -0.7227205038070679, 0.1336677074432373] ,
          [-0.7060924768447876, -0.6721756458282471, 0.003844320774078369] ,
          [-1.0992144346237183, -0.2984159290790558, -0.3602113127708435] ,
          [-0.7667078971862793, 0.15220430493354797, -0.5941405296325684] ,
          [-0.11075115203857422, 0.49231183528900146, -0.5244312286376953] ,
          [0.5635598301887512, 0.5080925822257996, 0.19439512491226196] ,
          [0.33408454060554504, 0.17587898671627045, 0.5896880030632019] ,
          [0.049795299768447876, -0.2573193609714508, 0.2643900215625763] ,
          [0.9681963920593262, 0.04270687699317932, -0.508962869644165] ,
          [1.0305646657943726, -0.04460831731557846, 0.148233562707901] ,
          [0.04545500874519348, 0.16707177460193634, 0.7802940011024475] ,
        ];
        let points3 = [
          [0.5591975450515747, -0.6449350118637085, -0.08891849219799042] ,
          [0.06542560458183289, -0.7017278075218201, -0.1129811555147171] ,
          [-0.9526462554931641, -0.43817344307899475, -0.5532508492469788] ,
          [-0.6645622253417969, -0.06056499481201172, -0.7273919582366943] ,
          [-0.044961512088775635, 0.2947380542755127, -0.6297612190246582] ,
          [0.6688201427459717, 0.36349010467529297, -0.038105934858322144] ,
          [0.31619200110435486, -0.4157463312149048, -0.08336275815963745] ,
          [0.8895507454872131, -0.1765936017036438, -0.689487636089325] ,
          [1.0444471836090088, -0.23999536037445068, 0.055383920669555664] ,
          [-0.0159529447555542, 0.09994816780090332, 0.7586202621459961] ,
        ];
        let points4 = [
          [0.5619691014289856, -0.6606542468070984, -0.24642160534858704] ,
          [0.1545190066099167, -0.6795598268508911, -0.2979204058647156] ,
          [-0.5258621573448181, -0.12445640563964844, -0.759310245513916] ,
          [0.11752727627754211, 0.1893543004989624, -0.6890183687210083] ,
          [0.7453016042709351, 0.18460357189178467, -0.1835387945175171] ,
          [0.6899829506874084, -0.2138972282409668, 0.24322056770324707] ,
          [0.525601327419281, -0.4008212089538574, -0.2196369171142578] ,
          [0.6583353281021118, -0.46498870849609375, -0.7020481824874878] ,
          [1.0658433437347412, -0.3778785765171051, -0.30356404185295105] ,
          [-0.09055757522583008, 0.049391329288482666, 0.6806945204734802] ,
        ];
        let points5 = [
          [0.5689328908920288, -0.6608929634094238, -0.3642052412033081] ,
          [-0.17437219619750977, -0.5822581052780151, -0.6037157773971558] ,
          [0.24909557402133942, 0.014367163181304932, -0.7490609884262085] ,
          [0.9292281866073608, -0.1680200695991516, 0.09326493740081787] ,
          [0.7344175577163696, -0.48141273856163025, -0.22066035866737366] ,
          [0.9607784748077393, -0.43136298656463623, -0.7336816787719727] ,
          [0.9734920263290405, -0.5645041465759277, -0.41893869638442993] ,
          [-0.11875784397125244, -0.047064900398254395, 0.6154443621635437] ,
        ];
        let points6 = [
          [0.581786036491394, -0.6506913304328918, -0.46333956718444824] ,
          [0.017280399799346924, -0.49776601791381836, -0.7011199593544006] ,
          [0.3238418698310852, -0.15448296070098877, -0.8192138671875] ,
          [1.0291413068771362, -0.14630809426307678, -0.14566737413406372] ,
          [0.9225907921791077, -0.41219353675842285, -0.16914832592010498] ,
          [0.9484508633613586, -0.5427040457725525, -0.694091260433197] ,
          [0.8770832419395447, -0.6132263541221619, -0.7502833008766174] ,
          [0.541313648223877, -0.6098572611808777, -0.1304832100868225] ,
          [-0.13694047927856445, -0.12192931771278381, 0.5347216725349426] ,
          
        ];
        let points7 = [
          [-0.1827540248632431, 0.5355103015899658, -1.2553637027740479] ,
          [-0.09617051482200623, 0.8978778123855591, -0.5843437314033508] ,
          [-0.06238517165184021, 1.0985472202301025, 0.012901968322694302] ,
          [-0.09690582752227783, 1.1972898244857788, 0.6200924515724182] ,
          [-0.18363219499588013, 1.213430643081665, 1.1427836418151855] ,
          [-0.25601303577423096, 1.179263710975647, 1.5538866519927979] ,
          [-0.3078622817993164, 1.0470463037490845, 1.9492628574371338] ,
          [-0.34715747833251953, 0.8817362785339355, 2.123802423477173] ,
          [-0.4247652292251587, 0.6079855561256409, 2.179666042327881] ,
          [-0.5005651712417603, 0.4674025774002075, 2.1213693618774414] ,
          [-0.602790355682373, 0.31081587076187134, 2.004338026046753] ,
          [-0.7458903789520264, 0.04191094636917114, 1.648139476776123] ,
          [-0.7549406290054321, -0.08760952949523926, 1.3091254234313965] ,
          [-0.7297235727310181, -0.1352473497390747, 1.1538848876953125] ,
          [-0.6813253164291382, -0.1486223340034485, 0.9902269840240479] ,
          [-0.5702996850013733, -0.10832938551902771, 0.751494288444519] ,
          [-0.001410365104675293, 0.2137327343225479, 0.3727887272834778] ,
          [0.7597098350524902, -0.5037145614624023, -0.4332447052001953] ,
          [0.8501427173614502, -0.3978559970855713, -0.5694954991340637] ,
          [0.4286842942237854, 0.35794851183891296, -0.13530588150024414] ,
          [-0.7011035680770874, 0.593153178691864, 0.7125741839408875] ,
          [-0.3334280848503113, 0.6809884309768677, 1.0358030796051025] ,
          [0.07249316573143005, 0.5670074224472046, 1.3131320476531982] ,
        ];
        let points8 = [
          [-0.2598159909248352, 0.4986114203929901, -1.26292085647583] ,
          [-0.17323246598243713, 0.860978901386261, -0.5919009447097778] ,
          [-0.13944709300994873, 1.0616482496261597, 0.005344714969396591] ,
          [-0.17396777868270874, 1.160390853881836, 0.6125351786613464] ,
          [-0.26069414615631104, 1.1765317916870117, 1.1352262496948242] ,
          [-0.3330749571323395, 1.142364740371704, 1.5463294982910156] ,
          [-0.3849242329597473, 1.0101473331451416, 1.9417054653167725] ,
          [-0.42421942949295044, 0.8448373675346375, 2.1162452697753906] ,
          [-0.5018271803855896, 0.5710866451263428, 2.1721086502075195] ,
          [-0.5776271224021912, 0.4305036962032318, 2.113812208175659] ,
          [-0.679852306842804, 0.27391695976257324, 1.9967808723449707] ,
          [-0.8229522705078125, 0.005012080073356628, 1.6405823230743408] ,
          [-0.8320025205612183, -0.12450841069221497, 1.3015682697296143] ,
          [-0.8067855834960938, -0.17214623093605042, 1.1463277339935303] ,
          [-0.7583872675895691, -0.1855212152004242, 0.9826697111129761] ,
          [-0.6473615765571594, -0.14522826671600342, 0.7439370155334473] ,
          [-0.0784723162651062, 0.176833838224411, 0.365231454372406] ,
          [0.6826479434967041, -0.5406134724617004, -0.4408019483089447] ,
          [0.7730807065963745, -0.4347549080848694, -0.5770527720451355] ,
          [0.3516223430633545, 0.32104963064193726, -0.14286312460899353] ,
          [-0.9953616857528687, 0.4198756217956543, 0.7877700924873352] ,
          [-1.3124313354492188, 0.8612797856330872, 0.9960379004478455] ,
        ];
        let points9 = [
          [-1.4268300533294678, 0.5282392501831055, 1.442781925201416] ,
          [-0.9393149614334106, 0.47427207231521606, 1.1148176193237305] ,
          [-0.3211548626422882, 0.19647563993930817, 1.4029994010925293] ,
          [-0.2654695510864258, -0.20806410908699036, 1.1709799766540527] ,
          [-0.37704116106033325, -0.24789202213287354, 0.19860121607780457] ,
          [0.009794026613235474, -0.2591816186904907, -0.5908591747283936] ,
          [-0.37090975046157837, -0.28821301460266113, -0.5737704038619995] ,
          [-0.7833046913146973, -0.24013066291809082, -0.28661829233169556] ,
          [-0.9059739112854004, -0.14957883954048157, 0.1987856924533844] ,
          [-1.0743038654327393, -0.022328078746795654, 0.5163706541061401] ,
          [-1.2000945806503296, 0.08090534806251526, 1.067972183227539] ,
          [-1.2464749813079834, 0.08332498371601105, 1.2817680835723877] ,
          [-1.2653818130493164, 0.048075005412101746, 1.5337622165679932] ,
          [-1.3972156047821045, 0.09169116616249084, 1.8061919212341309] ,
          [-1.6116387844085693, 0.202307790517807, 2.226999044418335] ,
        ];
        let points10 = [
          [-0.2544821500778198, 0.5370850563049316, -1.2435925006866455] ,
          [-0.16789862513542175, 0.8994525671005249, -0.5725725293159485] ,
          [-0.13411328196525574, 1.1001219749450684, 0.02467317134141922] ,
          [-0.16863393783569336, 1.1988645792007446, 0.6318636536598206] ,
          [-0.25536030530929565, 1.2150053977966309, 1.154554843902588] ,
          [-0.3277411460876465, 1.1808384656906128, 1.5656578540802002] ,
          [-0.37959039211273193, 1.0486210584640503, 1.9610340595245361] ,
          [-0.41888558864593506, 0.8833110332489014, 2.135573625564575] ,
          [-0.4964933395385742, 0.6095603108406067, 2.191437244415283] ,
          [-0.5722932815551758, 0.46897733211517334, 2.1331405639648438] ,
          [-0.6745184659957886, 0.31239062547683716, 2.0161092281341553] ,
          [-0.8176184892654419, 0.04348570108413696, 1.6599106788635254] ,
          [-0.8266687393188477, -0.08603477478027344, 1.3208966255187988] ,
          [-0.8014516830444336, -0.1336725950241089, 1.1656560897827148] ,
          [-0.7530534267425537, -0.14704757928848267, 1.0019981861114502] ,
          [-0.6420277953147888, -0.10675463080406189, 0.7632654905319214] ,
          [-0.07313847541809082, 0.21530748903751373, 0.3845599293708801] ,
          [0.6879817247390747, -0.5021398067474365, -0.42147350311279297] ,
          [0.7784146070480347, -0.39628124237060547, -0.5577242970466614] ,
          [0.3569561839103699, 0.3595232665538788, -0.1235346794128418] ,
          [-0.797835111618042, 0.7923672795295715, 0.7890741229057312] ,
          [-0.3637913763523102, 0.8077915906906128, 1.0308657884597778] ,
          [0.23789799213409424, 1.034891128540039, 0.631312370300293] ,
        ];
        let points11 = [
          [0.2470695972442627, 1.0690749883651733, 1.198657751083374] ,
          [0.03454628586769104, 0.9559504389762878, 1.5194048881530762] ,
          [-0.22449664771556854, 0.5647966861724854, 1.5706613063812256] ,
          [-0.29841938614845276, 0.17961277067661285, 1.3484036922454834] ,
          [-0.24273408949375153, -0.22492697834968567, 1.1163842678070068] ,
          [-0.2640818953514099, -0.24047183990478516, 0.11062104254961014] ,
          [0.03252950310707092, -0.27604448795318604, -0.6454548835754395] ,
          [-0.34033823013305664, -0.3070276379585266, -0.5878275036811829] ,
          [-0.6641468405723572, -0.23816734552383423, -0.3006749451160431] ,
          [-0.7868161201477051, -0.1476154625415802, 0.18472900986671448] ,
          [-1.0515682697296143, -0.03919094800949097, 0.46177491545677185] ,
          [-1.051905632019043, 0.04350563883781433, 0.6776170134544373] ,
          [-1.095400333404541, 0.06807665526866913, 0.7775675654411316] ,
          [-1.1773591041564941, 0.06404247879981995, 1.0133764743804932] ,
          [-1.2237396240234375, 0.06646211445331573, 1.2271723747253418] ,
          [-1.2498893737792969, 0.040274590253829956, 1.4729409217834473] ,
          [-1.2078231573104858, -0.0407046377658844, 1.7194874286651611] ,
          [-1.1109793186187744, -0.14563429355621338, 1.8081672191619873] ,
          [-0.9158323407173157, -0.2629043459892273, 1.8946077823638916] ,
          [-0.7045756578445435, -0.32962626218795776, 1.947758436203003] ,
        ];
        let points12 = [
          [-0.1827540248632431, 0.5355103015899658, -1.2553637027740479] ,
          [-0.09617051482200623, 0.8978778123855591, -0.5843437314033508] ,
          [-0.06238517165184021, 1.0985472202301025, 0.012901968322694302] ,
          [-0.09690582752227783, 1.1972898244857788, 0.6200924515724182] ,
          [-0.18363219499588013, 1.213430643081665, 1.1427836418151855] ,
          [-0.25601303577423096, 1.179263710975647, 1.5538866519927979] ,
          [-0.3078622817993164, 1.0470463037490845, 1.9492628574371338] ,
          [-0.34715747833251953, 0.8817362785339355, 2.123802423477173] ,
          [-0.4247652292251587, 0.6079855561256409, 2.179666042327881] ,
          [-0.5005651712417603, 0.4674025774002075, 2.1213693618774414] ,
          [-0.602790355682373, 0.31081587076187134, 2.004338026046753] ,
          [-0.7458903789520264, 0.04191094636917114, 1.648139476776123] ,
          [-0.7549406290054321, -0.08760952949523926, 1.3091254234313965] ,
          [-0.7297235727310181, -0.1352473497390747, 1.1538848876953125] ,
          [-0.6813253164291382, -0.1486223340034485, 0.9902269840240479] ,
          [-0.5702996850013733, -0.10832938551902771, 0.751494288444519] ,
          [-0.001410365104675293, 0.2137327343225479, 0.3727887272834778] ,
          [0.7597098350524902, -0.5037145614624023, -0.4332447052001953] ,
          [0.8501427173614502, -0.3978559970855713, -0.5694954991340637] ,
          [0.4286842942237854, 0.35794851183891296, -0.13530588150024414] ,
          [-0.7011035680770874, 0.593153178691864, 0.7125741839408875] ,
          [-0.3334280848503113, 0.6809884309768677, 1.0358030796051025] ,
          [0.07249316573143005, 0.5670074224472046, 1.3131320476531982] ,
        ];
        let points13 = [
          [-1.7064719200134277, 0.5983911752700806, 0.9297542572021484] ,
          [-0.9059028625488281, 0.46006083488464355, 1.1387648582458496] ,
          [-0.3155961036682129, 0.2237149327993393, 1.5898919105529785] ,
          [-0.21259570121765137, -0.0606265664100647, 1.118926763534546] ,
          [-0.45829880237579346, -0.2812143564224243, 0.1833629459142685] ,
          [-0.05786028504371643, -0.2678595781326294, -0.4026992917060852] ,
          [-0.2701168656349182, -0.26645439863204956, -0.5607584118843079] ,
          [-0.7379380464553833, -0.2478613257408142, -0.30187541246414185] ,
          [-0.8704230785369873, -0.1393856406211853, 0.030431296676397324] ,
          [-0.966590404510498, 0.037951186299324036, 0.2689771056175232] ,
          [-1.1092867851257324, 0.44940185546875, -0.2634393572807312] ,
          [-1.1171694993972778, 0.5441712141036987, -0.9750593304634094] ,
        ];
        //========== scale the curve to make it as large as you want
        let scale = 1;
        //========== Convert the array of points into vertices (in Blender the z axis is UP so we swap the z and y)

function getVertices(pointsArray) {

  for (var i = 0; i < pointsArray.length; i++) {
    var x = pointsArray[i][0] * scale;
    var y = pointsArray[i][1] * scale;
    var z = pointsArray[i][2] * scale;
    pointsArray[i] = new THREE.Vector3(x, z, -y);
  }
}

getVertices(points1);
getVertices(points2);
getVertices(points3);
getVertices(points4);
getVertices(points5);
getVertices(points6);
getVertices(points7);
getVertices(points8);
getVertices(points9);
getVertices(points10);
getVertices(points11);
getVertices(points12);
getVertices(points13);
       
        //========== Create a path from the points
        var curvePath1 =  new THREE.CatmullRomCurve3(points1);
        var curvePath2 =  new THREE.CatmullRomCurve3(points2);
        var curvePath3 =  new THREE.CatmullRomCurve3(points3);
        var curvePath4 =  new THREE.CatmullRomCurve3(points4);
        var curvePath5 =  new THREE.CatmullRomCurve3(points5);
        var curvePath6 =  new THREE.CatmullRomCurve3(points6);
        var curvePath7 =  new THREE.CatmullRomCurve3(points7);
        var curvePath8 =  new THREE.CatmullRomCurve3(points8);
        var curvePath9 =  new THREE.CatmullRomCurve3(points9);
        var curvePath10 =  new THREE.CatmullRomCurve3(points10);
        var curvePath11 =  new THREE.CatmullRomCurve3(points11);
        var curvePath12 =  new THREE.CatmullRomCurve3(points12);
        var curvePath13 =  new THREE.CatmullRomCurve3(points13);
        var radius = 0.005;
        //========== Create a tube geometry that represents our curve
        var geometry1 = new THREE.TubeGeometry( curvePath1, 600, radius*0.5, 5, false );
        var geometry2 = new THREE.TubeGeometry( curvePath2, 600, radius*0.5, 5, false );
        var geometry3 = new THREE.TubeGeometry( curvePath3, 600, radius*0.5, 5, false );
        var geometry4 = new THREE.TubeGeometry( curvePath4, 600, radius*0.5, 5, false );
        var geometry5 = new THREE.TubeGeometry( curvePath5, 600, radius*0.5, 5, false );
        var geometry6 = new THREE.TubeGeometry( curvePath6, 600, radius*0.5, 10, false );
        var geometry7 = new THREE.TubeGeometry( curvePath7, 600, radius*2, 10, false );
        var geometry8 = new THREE.TubeGeometry( curvePath8, 600, radius*2, 10, false );
        var geometry9 = new THREE.TubeGeometry( curvePath9, 600, radius*2, 10, false );
        var geometry10 = new THREE.TubeGeometry( curvePath10, 600, radius*2, 10, false );
        var geometry11 = new THREE.TubeGeometry( curvePath11, 600, radius*2, 10, false );
        var geometry12 = new THREE.TubeGeometry( curvePath12, 600, radius*2, 10, false );
        var geometry13 = new THREE.TubeGeometry( curvePath13, 600, radius*2, 10, false );
        //========== Set a different color for each face of the tube. (a triangle represents 1 face in WebGL)
       
        
        const points = curvePath1.getPoints(50);
        const geometry = new THREE.BufferGeometry().setFromPoints(points);
    
        // var pathMaterial = new THREE.LineDashedMaterial({
        //   color: 0xFFFFFF,
        //   linewidth: 3,
        //   scale: 1,
        //   dashSize: .1,
        //   gapSize: .1,
        // });;
    
     


         dashedMaterial = new THREE.LineDashedMaterial( {
          color: 0x77CDE7,
          linewidth: 30,
          scale: 1,
          dashSize: 4,
          isLineBasicMaterial: true,
          gapSize: 0.15,
          onBeforeCompile: shader => {
            shader.uniforms.time = dashUniforms.time;
            shader.fragmentShader = `
              uniform float time;
              ${shader.fragmentShader}
            `.replace(
              `vLineDistance,`,
              `vLineDistance - time,`
            );
          
              // console.log(shader.fragmentShader);

          }
        } );


           // Create the final object to add to the scene
           const curveObject = new THREE.Line(geometry, dashedMaterial);
           curveObject.computeLineDistances();
       
          //  scene.add(curveObject);
//         const dashedMaterial = new THREE.ShaderMaterial({
//           fragmentShader, dashedVertexShader,
//                   uniforms: {
//                         uColor: new THREE.Uniform(new THREE.Color(this.color)),
//                         uTime: new THREE.Uniform(0),
//                     }
//         })
        
      
//             update(t)
//             {
//                 this.mesh.material.uniforms.uTime.value = t;
//             }

//         const dashedVertexShader = `
// attribute vec3 aOffset;
// attribute vec2 aMetrics;
//   void main() {
//     vec3 transformed = position.xyz;

//     float radius = aMetrics.r;
//     float len = aMetrics.g;
//     transformed.xy *= radius; 
//     transformed.z *= len;

//             // 1. Add time, and it's position to make it move
//             float zOffset = uTime + aOffset.z;
		
//             // 2. Then place them in the correct position
//             transformed.z += zOffset;

//     transformed.xy += aOffset.xy;
	
//     vec4 mvPosition = modelViewMatrix * vec4(transformed,1.);
//     gl_Position = projectionMatrix * mvPosition;
// 	}
// `;


var bandMaterial = new THREE.MeshBasicMaterial( 
  { 
  color: 0x77CDE7,
  side: THREE.DoubleSide,
  onBeforeCompile: shader => {
    shader.uniforms.time = gu.time;
    shader.fragmentShader = `
      uniform float time;
      ${shader.fragmentShader}
    `.replace(
      `#include <clipping_planes_fragment>`,
      `
      float t = time ;
      vec2 uv = vUv;
      float dash = sin(uv.x*50.0 + t* (-5.15))+0.95;


      if (dash<0.) discard;
      #include <clipping_planes_fragment>`
    );
  }
} );
bandMaterial.defines = {"USE_UV": ""};
// var mesh = new THREE.Mesh( geometry, material );

 flowMaterial = new THREE.MeshLambertMaterial( 
  { 
    emissive: 0xDE4D69,
    emissiveIntensity: 1.2,
  color: 0xDE4D69,
  // side: THREE.DoubleSide,
  onBeforeCompile: shader => {
    shader.uniforms.time = gu.time;
    shader.fragmentShader = `
      uniform float time;
      ${shader.fragmentShader}
    `.replace(
      `#include <clipping_planes_fragment>`,
      `
      float t = time * (0.25);
      vec2 uv = vUv;
      if (fract(uv.x + t) < 0.5) discard;
      #include <clipping_planes_fragment>`
    );
  }
} );
flowMaterial.defines = {"USE_UV": ""};
    // color:0xC72732});
        var tube1 = new THREE.Mesh( geometry1, bandMaterial );
        var tube2 = new THREE.Mesh( geometry2, bandMaterial );
        var tube3 = new THREE.Mesh( geometry3, bandMaterial );
        var tube4 = new THREE.Mesh( geometry4, bandMaterial );
        var tube5 = new THREE.Mesh( geometry5, bandMaterial );
        var tube6 = new THREE.Line( geometry6, bandMaterial );

        // var tube1 = new THREE.Line( geometry1, dashedMaterial );
        // var tube2 = new THREE.Line( geometry2, dashedMaterial );
        // var tube3 = new THREE.Line( geometry3, dashedMaterial );
        // var tube4 = new THREE.Line( geometry4, dashedMaterial );
        // var tube5 = new THREE.Line( geometry5, dashedMaterial );
        var tube7 = new THREE.Line( geometry7, flowMaterial );
        var tube8 = new THREE.Line( geometry8, flowMaterial );
        var tube9 = new THREE.Line( geometry9, flowMaterial );
        var tube10 = new THREE.Line( geometry10, flowMaterial );
        var tube11 = new THREE.Line( geometry11, flowMaterial );
        var tube12 = new THREE.Line( geometry12, flowMaterial );
        var tube13 = new THREE.Line( geometry13, flowMaterial );
        // scene.add( tube1, tube2, tube3, tube4, tube5, tube6, tube7, tube8, tube9, tube10, tube11, tube12, tube13 );

        var plane = new THREE.Plane( new THREE.Vector3(0, 0, 1), 0 );
        const helper = new THREE.PlaneHelper( plane, 2, 0xffffff );
        // plane.position.set(0.01, 0, 0);
        // scene.add( helper );



group.add( heartObj.children[0], heartObj.children[1],tube1, tube2, tube3, tube4, tube5, tube6, tube7, tube8, tube9, tube10, tube11, tube12, tube13 , cyl );
group2.add( group );
        scene.add(group2)
// group2.rotation.y=1.5*Math.PI;
// group2.rotation.x=1.5*Math.PI;

initRotation = new THREE.Quaternion().setFromEuler(new THREE.Euler(1.5 * Math.PI, 1.5 * Math.PI, 0));

group2.rotation.set(initRotation.x, initRotation.y, initRotation.z, initRotation.order);

group.scale.set(0.005,0.005,0.005);

        var raycaster = new THREE.Raycaster();
        var mouse = new THREE.Vector2();
        window.addEventListener("mousemove", event => {
        
          mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
          mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

          raycaster.setFromCamera(mouse, camera);
          
          raycaster.ray.intersectPlane(plane, uniforms.mouse.value);
        
          targetRotation.setFromEuler(new THREE.Euler(-mouse.y*.5, mouse.x*.5, 0));

  //          group.rotation.y = mouse.x * .15;
  // group.rotation.x = mouse.y * -.15;
      
        });
  });






    // camera.lookAt(heartObj.children[0].position);

    // scene.add(cube)
    // renderer.setClearColor('#000000')
    renderer.setSize(width, height)

    const renderScene = () => {
      // renderer.render(scene, camera)
          // console.log(renderer.info)

composer.render();
    }

    const handleResize = () => {
      width = mount.current.clientWidth
      height = mount.current.clientHeight
      renderer.setSize(width, height)
      composer.setSize(width, height)

      camera.aspect = width / height
      camera.updateProjectionMatrix()
      camera.position.z = 4*(window.innerWidth+cameraScale)/window.innerWidth;

      renderScene()
    }
//     let l = new THREE.Line(g, dashedMaterial);
// l.computeLineDistances();
// scene.add(l);


    const animate = () => {
// if (heartObj) 
//      { 
//       heartObj.rotation.x += 0.01
//       heartObj.rotation.y += 0.01
// }
// console.log(dashedMaterial)


  // group.rotation.y = mouse.x * .15;
  // group.rotation.x = mouse.y * -.15;


  let t = clock.getElapsedTime();
  gu.time.value = t;
dashUniforms.time.value = clock.getElapsedTime()*3;

// if (t >= 3.0)
// {
//     clock = new THREE.Clock;
//     group.scale.set(1,1,1);
// }
// else
// if (group.scale.x <=(1-.01))
// {
//   group.scale.x= (Math.sin(t*0.75));
//   group.scale.y = (Math.sin(t*0.75));
//   group.scale.z = (Math.sin(t*0.75));   
//   // console.log(t/3.0)
//   //lerp group scale to 1

// }

setTimeout (function() {

// Assume that you have a reference to the object's scale as a Vector3 object called "scale"

// Set the target scale value
const targetScale = new THREE.Vector3(1, 1, 1, 1);

// Set the interpolation factor (e.g., 0.1 for a smooth, gradual transition)
const scaleT = 1.0;

let scaleCopy = group.scale.clone();

// Interpolate the scale
scaleCopy.lerp(targetScale, scaleT);

// Update the object's scale
group.scale.copy(scaleCopy);


group.quaternion.slerp(targetRotation, 0.05);



group.quaternion.slerp(targetRotation, 0.05);




const endRotation = new THREE.Quaternion().setFromEuler(new THREE.Euler(2*Math.PI, 2*Math.PI, 0));

// Set up the easing factor
const easing = 0.05;
group2.quaternion.slerp(endRotation, easing);
}, 500);


      renderScene()
      frameId = window.requestAnimationFrame(animate)
      
  }

    const start = () => {
      if (!frameId) {
        frameId = requestAnimationFrame(animate)
      }
    }

    const stop = () => {
      cancelAnimationFrame(frameId)
      frameId = null
    }

    mount.current.appendChild(renderer.domElement)
    window.addEventListener('resize', handleResize)
    start()

    controls.current = { start, stop }

    return () => {
      stop()
      window.removeEventListener('resize', handleResize)
     
      scene.remove(heartObj)
      geometry.dispose()
      material.dispose()
      composer.dispose()
      renderer.dispose()

 if (mount.current) 
{      mount.current.removeChild(renderer.domElement)
}

    }
  }, [])


  // useFrame(() => {
  //   if (heartLoaded)
  //   dashedMaterial.current.uniforms.dashOffset.value -= 2.5;
  // });


  useEffect(() => {
    if (location.pathname !== '/') {

//set timeout to 0 to make sure it runs after the page has changed
      setTimeout(() => {

        if (heartObj) 
        {
        heartObj.traverse( function ( object ) { object.visible = false; } );}
        document.querySelector('.heartScene').style.opacity = '0';
        console.log('Page has changed', location.pathname);
        controls.current.stop()      }, 1000)


    }

    else  {
controls.current.start()
      setTimeout(() => {
        if (heartObj) 

{        heartObj.traverse( function ( object ) { object.visible = true; } );
}
      document.querySelector('.heartScene').style.opacity = '1';
      console.log('Page has changed', location.pathname);
      }, 1000)
    }
    // previousLocation.current = location;
  }, [location]);

  useEffect(() => {
    if (isAnimating) {
      controls.current.start()
    } else {
      controls.current.stop()
      
    }
  }, [isAnimating])
  
  return (
  <>
  
  <div id="loader-wrapper" >
    <div id="loader">

      <div className="progress-text">
        <p className="flashing-animation">Loading</p>
      </div>
      <div className="progress-bar">
        <div className="progress-bar__fill"></div>
      </div>
    </div>

    <div className="loader-section" id="section-top"></div>
    <div className="loader-section" id="section-bottom"></div>

  </div>

  <div className='heartScene' ref={mount} style={{position:'absolute', width: '100%', height: '100%', top:0, zIndex:'-5'}}            
  // onClick={() => 
  //   setAnimating(!isAnimating)}
  
  
           >

<div className="blend-mask"></div>

           </div>
           
           
           </>
           )
}

// ReactDOM.render(<HeartScene />, document.getElementById('root'))

export default HeartScene;